import { fetcher } from "helpers/fetcher";

import { TCreateJobListingReq, TCreateJobListingRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const createJobListing = async (payload?: TCreateJobListingReq) => {
  return await fetcher<TCreateJobListingRes, TCreateJobListingReq["data"]>(
    ENDPOINT.CORPORATION.CREATE_JOB_LISTING,
    {
      data: payload?.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.CORPORATION.CREATE_JOB_LISTING.version,
        [API_HEADER.CORP_ID]: payload?.idCorp,
      },
    }
  );
};

export const mutationCreateJobListing = async (
  payload?: TCreateJobListingReq
) => {
  return (await createJobListing(payload)).data;
};

mutationCreateJobListing._key = (payload?: TCreateJobListingReq) => [
  ENDPOINT.CORPORATION.CREATE_JOB_LISTING.url,
  payload,
];
